import { SessionStorageUnits } from '../../config/sessionStorage'
import { getFromSessionStorage, saveToSessionStorage } from '../../utils/sessionStorage'
import { IDE_AUTH_URL_PATH_NAME } from '../ideInteraction'

import { type AttributionStash, UTM_DIMENSIONS } from './origin'

/**
 * Captures user-origin signals (utm_* + IDE landing + referrer) on the first anonymous
 * landing, before the OAuth redirect strips the query string. First-touch wins: an existing
 * stash is never overwritten. Always writes a stash on the first landing (an empty stash maps
 * to `direct`), so every new user is classifiable.
 */
export function captureAttribution(): void {
	if (typeof window === 'undefined') {
		return
	}

	if (getAttributionStash()) {
		return
	}

	const params = new URLSearchParams(window.location.search)
	const stash: AttributionStash = {}

	for (const dimension of UTM_DIMENSIONS) {
		const value = params.get(dimension.param)
		if (value) {
			stash[dimension.key] = value
		}
	}

	if (window.location.pathname.startsWith(IDE_AUTH_URL_PATH_NAME)) {
		stash.cameFromIde = true
	}

	if (document.referrer) {
		stash.referrer = document.referrer
	}

	saveToSessionStorage(SessionStorageUnits.userAttribution, stash)
}

export function getAttributionStash(): AttributionStash | null {
	return getFromSessionStorage<AttributionStash>(SessionStorageUnits.userAttribution) ?? null
}
